module.exports = "https://static.wanderu.com/static/media/sad-chiku.d5ce2a21.svg";